// extracted by mini-css-extract-plugin
export default {"partners":"Partners_partners__bxEcT","partners__de":"Partners_partners__de__pnKrX","partners__wrapper":"Partners_partners__wrapper__kfrAx"};